import { render } from "./DefinePasswordControl.vue?vue&type=template&id=09f6754e&scoped=true&ts=true"
import script from "./DefinePasswordControl.vue?vue&type=script&lang=ts"
export * from "./DefinePasswordControl.vue?vue&type=script&lang=ts"

import "./DefinePasswordControl.vue?vue&type=style&index=0&id=09f6754e&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\2f08168a1cda37d3\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f6754e"]])

export default __exports__